// @generated
import { PapiDeviation } from '@wix/da-papi-types';

const emptyMedia = {
  types: [
    {
      t: '150',
      r: -2,
      s: 'https://st.deviantart.net/minish/stash/stash-empty-item_120.png',
      h: 120,
      w: 120,
    },
    {
      t: '200H',
      r: -2,
      s: 'https://st.deviantart.net/minish/stash/stash-empty-item_240.png',
      h: 200,
      w: 200,
    },
    {
      t: '300W',
      r: -2,
      s: 'https://st.deviantart.net/minish/stash/stash-empty-item_240.png',
      h: 240,
      w: 240,
    },
    {
      t: '375W',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: '414W',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: '250T',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: '350T',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: '400T',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: 'preview',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: 'social_preview',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: 'fullview',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
    {
      t: '125S',
      r: -2,
      s: 'https://st.deviantart.net/minish/bears/empty-544.png',
      h: 211,
      w: 544,
    },
  ],
};

export const pdfDeviations: PapiDeviation[] = [
  {
    deviationId: 650857090,
    typeId: 1,
    url: 'https://www.deviantart.com/alexiuss/art/Embrace-the-dawn-cd-cover-art-with-lyrics-650857090',
    title: 'Embrace the dawn: [cd cover art with lyrics]',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2016-12-12T09:05:50-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 851331,
      useridUuid: '5ab0b6ce-f97e-4834-b089-8a0d050ab762',
      username: 'alexiuss',
      usericon: 'https://a.deviantart.net/avatars-big/a/l/alexiuss.png?9',
      type: 'senior',
      isNewDeviant: false,
    },
    stats: {
      comments: 89,
      favourites: 3554,
    },
    media: emptyMedia,
  },
  {
    deviationId: 628263550,
    typeId: 1,
    url: 'https://www.deviantart.com/aliatheghoul/art/Miniature-Mage-Tutorial-PDF-628263550',
    title: 'Miniature Mage Tutorial (PDF)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2016-08-14T17:06:24-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 13891622,
      useridUuid: 'c2749a70-6cd8-4795-993d-499fd86c8805',
      username: 'AliatheGhoul',
      usericon: 'https://a.deviantart.net/avatars-big/a/l/aliatheghoul.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 42,
    },
    media: emptyMedia,
  },
  {
    deviationId: 78245201,
    typeId: 1,
    url: 'https://www.deviantart.com/billybob884/art/Portal-Turret-PDF-pgs-1-2-78245201',
    title: 'Portal Turret PDF pgs 1-2',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2008-02-23T17:06:20-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1154499,
      useridUuid: '535fb822-5299-44ac-8e4a-283ffa2e3bed',
      username: 'billybob884',
      usericon: 'https://a.deviantart.net/avatars-big/b/i/billybob884.gif?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 125,
      favourites: 511,
    },
    media: emptyMedia,
  },
  {
    deviationId: 313903528,
    typeId: 1,
    url: 'https://www.deviantart.com/coralle/art/Chukar-Partridge-Crochet-Pattern-PDF-313903528',
    title: 'Chukar Partridge Crochet Pattern PDF',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2012-07-10T17:36:16-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1953760,
      useridUuid: 'f7abb331-4be8-4fc9-ad5e-505d6ec7c2e1',
      username: 'Coralle',
      usericon: 'https://a.deviantart.net/avatars-big/c/o/coralle.jpg?14',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 38,
    },
    media: emptyMedia,
  },
  {
    deviationId: 432172759,
    typeId: 1,
    url: 'https://www.deviantart.com/gannjondal/art/To-Cage-The-Dragon-PDF-version-432172759',
    title: 'To Cage The Dragon - PDF version',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-02-06T01:19:58-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 21811251,
      useridUuid: '48a0a8e0-9de7-4bc9-9dfc-b24f46f677f1',
      username: 'gannjondal',
      usericon: 'https://a.deviantart.net/avatars-big/g/a/gannjondal.png?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 19,
      favourites: 39,
    },
    media: emptyMedia,
  },
  {
    deviationId: 209490830,
    typeId: 1,
    url: 'https://www.deviantart.com/wolfepaw/art/Titia-FE-Tutorial-English-pdf-209490830',
    title: 'Titia FE Tutorial English pdf',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2011-05-19T13:48:04-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 7132398,
      useridUuid: '9962c0a5-f99e-4770-9d7e-769e56273503',
      username: 'wolfepaw',
      usericon: 'https://a.deviantart.net/avatars-big/w/o/wolfepaw.jpg?8',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 41,
      favourites: 49,
    },
    media: emptyMedia,
  },
  {
    deviationId: 63791520,
    typeId: 1,
    url: 'https://www.deviantart.com/billybob884/art/Halo-Ringworld-PDF-pages-1-2-63791520',
    title: 'Halo Ringworld PDF pages 1-2',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-08-31T22:09:43-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1154499,
      useridUuid: '535fb822-5299-44ac-8e4a-283ffa2e3bed',
      username: 'billybob884',
      usericon: 'https://a.deviantart.net/avatars-big/b/i/billybob884.gif?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 81,
    },
    media: emptyMedia,
  },
  {
    deviationId: 437887403,
    typeId: 1,
    url: 'https://www.deviantart.com/limitlessendeavours/art/PDF-Plaster-Shell-Mold-Tutorial-437887403',
    title: 'PDF Plaster Shell Mold Tutorial',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-03-02T20:18:48-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18039411,
      useridUuid: 'bf856274-28a3-4288-b70b-8993722f3a31',
      username: 'LimitlessEndeavours',
      usericon: 'https://a.deviantart.net/avatars-big/l/i/limitlessendeavours.gif?11',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 25,
      favourites: 368,
    },
    media: emptyMedia,
  },
  {
    deviationId: 63500270,
    typeId: 1,
    url: 'https://www.deviantart.com/billybob884/art/N64-Logo-PDF-pages-1-3-63500270',
    title: 'N64 Logo PDF pages 1-3',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-08-28T09:59:56-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1154499,
      useridUuid: '535fb822-5299-44ac-8e4a-283ffa2e3bed',
      username: 'billybob884',
      usericon: 'https://a.deviantart.net/avatars-big/b/i/billybob884.gif?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 91,
    },
    media: emptyMedia,
  },
  {
    deviationId: 73060387,
    typeId: 1,
    url: 'https://www.deviantart.com/billybob884/art/Gregg-the-Reaper-PDF-pgs-1-5-73060387',
    title: 'Gregg the Reaper PDF pgs 1-5',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-12-26T22:38:36-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1154499,
      useridUuid: '535fb822-5299-44ac-8e4a-283ffa2e3bed',
      username: 'billybob884',
      usericon: 'https://a.deviantart.net/avatars-big/b/i/billybob884.gif?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 60,
    },
    media: emptyMedia,
  },
  {
    deviationId: 63668540,
    typeId: 1,
    url: 'https://www.deviantart.com/billybob884/art/Conker-CBFD-PDF-pages-1-10-63668540',
    title: "Conker 'CBFD' PDF pages 1-10",
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2007-08-30T12:28:45-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1154499,
      useridUuid: '535fb822-5299-44ac-8e4a-283ffa2e3bed',
      username: 'billybob884',
      usericon: 'https://a.deviantart.net/avatars-big/b/i/billybob884.gif?1',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 60,
    },
    media: emptyMedia,
  },
  {
    deviationId: 649312976,
    typeId: 1,
    url: 'https://www.deviantart.com/sakon04/art/Tutorial-Lining-Sakon-pdf-649312976',
    title: 'Tutorial Lining Sakon (pdf)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2016-12-03T20:11:26-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 15043388,
      useridUuid: '5b0a21f5-37dc-445c-ae37-0eab546ae1ef',
      username: 'Sakon04',
      usericon: 'https://a.deviantart.net/avatars-big/s/a/sakon04.gif?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 37,
      favourites: 367,
    },
    media: emptyMedia,
  },
];
